import * as React from "react";
import { useId } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGlobe = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		viewBox: "0 0 20 20",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M2.09863 10.0986H18.0986M2.09863 10.0986C2.09863 14.5169 5.68035 18.0986 10.0986 18.0986M2.09863 10.0986C2.09863 5.68035 5.68035 2.09863 10.0986 2.09863M18.0986 10.0986C18.0986 14.5169 14.5169 18.0986 10.0986 18.0986M18.0986 10.0986C18.0986 5.68035 14.5169 2.09863 10.0986 2.09863M10.0986 2.09863C12.0997 4.28932 13.2368 7.13226 13.2986 10.0986C13.2368 13.065 12.0997 15.908 10.0986 18.0986M10.0986 2.09863C8.09761 4.28932 6.96043 7.13226 6.89863 10.0986C6.96043 13.065 8.09761 15.908 10.0986 18.0986",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	});
};
export default SvgGlobe;
